/**
 * Wire protocol message type constants for the cf_agent_chat_* protocol.
 *
 * These are the string values used on the wire between agent servers and
 * clients. Both @cloudflare/ai-chat (via its MessageType enum) and
 * @cloudflare/think use these values.
 */
export const CHAT_MESSAGE_TYPES = {
  CHAT_MESSAGES: "cf_agent_chat_messages",
  USE_CHAT_REQUEST: "cf_agent_use_chat_request",
  USE_CHAT_RESPONSE: "cf_agent_use_chat_response",
  CHAT_CLEAR: "cf_agent_chat_clear",
  CHAT_REQUEST_CANCEL: "cf_agent_chat_request_cancel",
  STREAM_RESUMING: "cf_agent_stream_resuming",
  STREAM_RESUME_ACK: "cf_agent_stream_resume_ack",
  STREAM_RESUME_REQUEST: "cf_agent_stream_resume_request",
  STREAM_RESUME_NONE: "cf_agent_stream_resume_none",
  TOOL_RESULT: "cf_agent_tool_result",
  TOOL_APPROVAL: "cf_agent_tool_approval",
  MESSAGE_UPDATED: "cf_agent_message_updated"
} as const;
